import { gql } from '__generated__';

export default gql(`
  mutation ActivateTicket($id: ID!) {
    activateTicket(id: $id) {
      id
      active
    }
  }
`);
